import { loginPost } from "../../../api/auth";
import router from '@/router'

export default {
  async login({ commit }, payload) {
    return loginPost(payload)
      .then(res => {
        commit('setAccessToken', res.data.access_token)
        router.push({ name: 'dashboard' })
      })
  },
  updateAuthToken ({ commit }, payload) {
    commit('setAccessToken', payload.access_token)
    router.push({ name: 'dashboard' })
  }
}
